export default {
  order: {
    title: "Pedido",
    pickupDate: "Fecha de recogida",
    pickup: "Lugar de recogida",
    dropoff: "Lugar de destino",
    passenger: "Pasajero",
    comment: "Comentario",
    vehicle: "Vehículo",
    chauffeur: "Conductor",
    passengersCount: "Pasajeros",
    childSeats: "Asientos para niños",
    flightNumber: "Número de vuelo",
    nameSign: "Cartel con nombre",
    speaks: "Habla",
    call: "Llamar",
    licensePlate: "Matrícula",
    category: "Categoría",
    status: {
      new: "Confirmación pendiente",
      confirmed: "Pedido confirmado",
      on_my_way: "En ruta",
      at_the_location: "Llegado al lugar",
      pob: "Pasajero a bordo",
      clear: "Pedido completado",
      no_show: "Pasajero no apareció",
      canceled: "Pedido cancelado"
    },
    statusDescriptions: {
      new: "Pedido pendiente de confirmación del proveedor",
      confirmed: "Proveedor confirmó el pedido, esperando inicio",
      on_my_way: "Conductor en ruta al lugar de recogida",
      at_the_location: "Conductor llegó y espera al pasajero",
      pob: "Pasajero abordó, en ruta al destino",
      clear: "Pedido completado con éxito",
      no_show: "El pasajero no apareció en el lugar de recogida",
      canceled: "Pedido cancelado"
    },
    messages: {
      noChauffeurAssigned: "Su conductor aún no ha sido asignado",
      detailsWillAppear: "Los detalles aparecerán aquí una vez asignados",
      unknown: "Desconocido",
      started: "Iniciado",
      awaitingAssignment: "Esperando asignación"
    },
    childSeatsTypes: {
      child_01: "Portabebés (6 meses)",
      child_02: "Asiento convertible (0-7 años)",
      child_03: "Asiento elevador (6-12 años)"
    },
    distance: "{distance} km",
    review: "Valora tu viaje",
    review_status: {
      perfect: 'Perfecto',
      good: 'Bueno',
      average: 'Regular',
      bad: 'Malo',
      terrible: 'Pésimo'
    }
  },
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    loading: "Cargando...",
    error: "Error"
  }
}